module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.date !== null) ? _c('div', {
    staticClass: "overview"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("\n            " + _vm._s(_vm._f("moment")(_vm.date, 'MMMM \'YY')) + " \n\n            "), _c('small', {
    staticClass: "controls"
  }, [_c('span', {
    staticClass: "pe-7s-angle-left-circle navigatable",
    on: {
      "click": function($event) {
        return _vm.previous()
      }
    }
  }), _vm._v(" \n                "), _c('span', {
    staticClass: "pe-7s-angle-right-circle navigatable",
    on: {
      "click": function($event) {
        return _vm.next()
      }
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "hidden-print"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-fill btn-sm",
    attrs: {
      "to": {
        name: 'reservations.create'
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus fa-fw"
  }), _vm._v("\n                    Add new\n                ")])], 1), _vm._v(" "), (!_vm.isGroupedInvoice) ? _c('small', {
    staticClass: "hidden-print"
  }, [_c('button', {
    staticClass: "btn btn-default btn-fill btn-sm",
    on: {
      "click": _vm.groupInvoice
    }
  }, [_vm._v("\n                    Grouped invoice\n                ")])]) : _c('small', {
    staticClass: "hidden-print"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-fill btn-sm",
    on: {
      "click": _vm.groupInvoice
    }
  }, [_vm._v("\n                    Apply\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('date-picker', {
    attrs: {
      "config": {
        format: 'MMMM YYYY'
      }
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1)])]), _vm._v(" "), (!_vm.hasLoaded) ? _c('loader') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "calendar"
  }, [_c('div', [(_vm.date && _vm.hasLoaded) ? _c('header-block', {
    attrs: {
      "date": _vm.date
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.rooms), function(room) {
    return _c('room', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.hasLoaded),
        expression: "hasLoaded"
      }],
      key: room.id,
      attrs: {
        "room": room,
        "date": _vm.date,
        "groupedInvoice": _vm.isGroupedInvoice,
        "groupedReservations": _vm.groupedReservations
      },
      on: {
        "reservationsLoaded": function($event) {
          _vm.loaded++
        },
        "reservationsGroup": _vm.group
      }
    })
  })], 2)])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a9ab42c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/reservations/Reservations.vue
// module id = 405
// module chunks = 1